import axiosInstance from "../lib/axios";
import {
  LoginCredentials,
  LoginResponse,
  UpdateProfilePayload,
  ChangePasswordPayload,
  ForgotPasswordPayload,
  VerifyOtpPayload,
  VerifyOtpResponse,
  ResetPasswordPayload,
} from "../types/auth";

export const authService = {
  login: async (credentials: LoginCredentials): Promise<LoginResponse> => {
    const response = await axiosInstance.post("/admin/auth/login", credentials);
    return response.data;
  },

  logout: async () => {
    const response = await axiosInstance.post("/admin/auth/logout");
    return response.data;
  },

  forgotPassword: async (payload: ForgotPasswordPayload) => {
    const response = await axiosInstance.post(
      "/admin/auth/forgot-password",
      payload,
    );
    return response.data;
  },

  verifyOtp: async (payload: VerifyOtpPayload): Promise<VerifyOtpResponse> => {
    const response = await axiosInstance.post(
      "/admin/auth/verify-reset-otp",
      payload,
    );
    return response.data;
  },

  resetPassword: async (payload: ResetPasswordPayload) => {
    const response = await axiosInstance.post(
      "/admin/auth/reset-password",
      payload,
    );
    return response.data;
  },

  getProfile: async () => {
    const response = await axiosInstance.get("/admin/account/profile");
    return response.data;
  },

  updateProfile: async (payload: UpdateProfilePayload) => {
    const response = await axiosInstance.put("/admin/account/profile", payload);
    return response.data;
  },

  changePassword: async (payload: ChangePasswordPayload) => {
    const response = await axiosInstance.put(
      "/admin/account/profile/password",
      payload,
    );
    return response.data;
  },
};
